import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatTableModule,MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,MatColumnDef,MatCellDef, MatHeaderCellDef, MatHeaderCell, MatCell } from '@angular/material/table';
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { MatDialogModule, MatDialog, MatDialogConfig, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { PreviewDialogComponent } from '../preview-dialog/preview-dialog.component';
import { MatCheckbox, MatCheckboxModule } from "@angular/material/checkbox";
import { MatSort } from '@angular/material/sort';
import { DbService, DeleteRow, UploadTemplate } from '../service/db-service.service';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StorageMbPipe } from "../service/storage-mb.pipe";
import { MatIcon } from "@angular/material/icon";
@Component({
  selector: 'app-show-uploads',
  imports: [MatHeaderRow, MatTableModule, MatTable, MatHeaderRow, MatColumnDef, MatHeaderRow, MatRow, MatRowDef, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatHeaderCell, MatCell, MatPaginatorModule, MatDialogModule, MatDialogContent, MatDialogActions, MatCheckbox, MatCheckboxModule, MatRadioGroup, MatRadioButton, StorageMbPipe, MatIcon],
  templateUrl: './show-uploads.component.html',
  styleUrl: './show-uploads.component.sass'
})
export class ShowUploadsComponent {
@ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) matTable: MatTable<any>;
  @ViewChild('successfullySave') successfullySave!: TemplateRef<any>;
   
  selectedForDelRows: string[] = [];
  showCheckboxSelectMap: Map<string, boolean> = new Map();
  showDelArchiveSelectMap:Map<string, string> = new Map(); 
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['description', 'myname', 'actions', 'deletions'];
  unsavedChanges = false;
  unsavedChangesCount = 0;
  previewUrl: string;
  previewVisible = false;
  isVideo = false;
  previewFileType = '';
  constructor(private dialog: MatDialog,  public dbService: DbService, private http: HttpClient) {
    this.dbService.delItemsByPhoneMap = new Map();
  }

  ngAfterViewInit() {
    this.dbService.dataSource.sort = this.sort;
    this.dbService.dataSource.paginator = this.paginator;
  }

  delete(id: string){
    const index = this.selectedForDelRows.indexOf(id);
    if(index != -1){
      this.showCheckboxSelectMap.set(id, true);
      let deletedRow: any;
      const indexToRemove = this.dbService.tableDataArray.findIndex(obj => obj.id === id);
      if (indexToRemove !== -1) {
        deletedRow = this.dbService.tableDataArray.splice(indexToRemove, 1)[0]; // Remove 1 element at the found index
      }
      console.log("class name is" + typeof(this.dbService.updatedTemplatesMap))
      const mode = this.showDelArchiveSelectMap.get(id);
      const isArchiveMode = mode == "archive";
      if(this.dbService.uploadStagingMap.has(id)){
        this.dbService.uploadStagingMap.delete(id);
        this.dbService.uploadStagingModified = true;
      }
      if(isArchiveMode){
        const archiveRow = this.dbService.updatedTemplatesMap.get(id);
        this.dbService.archivedTemplatesMap.set(id, archiveRow);
      }
      const result = this.dbService.updatedTemplatesMap.delete(id);
      console.log("result is:" + result);
      let delArr = [];
      if(this.dbService.delItemsByPhoneMap.has(deletedRow.phone)){
        delArr = this.dbService.delItemsByPhoneMap.get(deletedRow.phone);
      }else{
         this.dbService.delItemsByPhoneMap.set(deletedRow.phone, delArr);
      }
      let templateData = {v4param1:deletedRow.v4param1, v4param2:deletedRow.v4param2, v4param3:deletedRow.v4param3}
      const tempDelRow: DeleteRow = {isarchivemode: isArchiveMode, templatedata: templateData, mediaid: id, filename: deletedRow.filename, filetype: deletedRow.filetype, thumbfilename: deletedRow.thumbfile};
      delArr.push(tempDelRow);
      this.unsavedChanges = true;
      this.unsavedChangesCount = delArr.length;
      this.matTable.renderRows();
    }else{
      this.showCheckboxSelectMap.set(id, false);
    }
    /*const mapObj = this.dbService.previewdImageUrlMap.get(id);
    console.log("mapObj:" + JSON.stringify(mapObj));
    this.openPreviewDialog(id, true);
    console.log(`Deleting file with id: ${mapObj.username} and url: ${mapObj.previewurl}`);*/

  }
  
  preview(img: any){
    console.log(JSON.stringify(img));
    firstValueFrom(this.dbService.generateImageUrl(img, this.http))
    .then((resp) => {
      this.previewUrl = resp["url"];
      this.previewVisible = true;
      this.isVideo = img.filetype.includes('video');  
      if(img.filetype.includes('quicktime')){ 
        this.previewFileType = 'video/mp4';
      }else{
        this.previewFileType = img.filetype;
      }
      this.dbService.previewdImageUrlMap.set(img.id, {username: img.myname, phone: img.phone, previewurl: this.previewUrl, isvideo:this.isVideo, previewfiletype: this.previewFileType, description: img.description, imageid: img.id, filename:img.filename, filetype: img.filetype, thumbfile: img.thumbfile});
      this.openPreviewDialog(img.id, false);
      //this.openPreviewDialog(img.myname, img.description, false, img.row);
    })    
  }

  openPreviewDialog(id: string,deleteArchive: boolean): void {
      const mapObj = this.dbService.previewdImageUrlMap.get(id);
      let  delArr = [];
      const key = mapObj["phone"];
      if(deleteArchive){
        if(!this.dbService.delItemsByPhoneMap.has(key)){
          this.dbService.delItemsByPhoneMap.set(key, delArr);
        }
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true; // Prevent closing by clicking outside
      dialogConfig.autoFocus = true; // Focus the first tabbable element
      //{username: img.myname, previewurl: this.previewUrl, isvideo:this.isVideo, previewfiletype: this.previewFileType, description: img.description, imagid: img.id, index: index}
      let tempThumbfile = mapObj.thumbfile;
      if(mapObj.filetype.includes("image")){
        tempThumbfile = "none";
      }
      dialogConfig.data = { // Pass data to the dialog component
        phone: key,
        message: `Posted by ${mapObj.username}`,
        previewUrl: mapObj.previewurl,
        isVideo: mapObj.isvideo,
        previewFileType: mapObj.previewfiletype,
        description: mapObj.description,
        isDeleteArchiveMode: deleteArchive,
        mediaid: id,
        filename: mapObj.filename,
        thumbfile: tempThumbfile,
        filetype: mapObj.filetype
      };
  
      const dialogRef = this.dialog.open(PreviewDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const dialogResult = result as { result: string};
          if (dialogResult.result == "delete item") {
              this.unsavedChanges = true;
              this.unsavedChangesCount++;
              this.matTable.renderRows();
            } else {
              console.log('User cancelled');
          }
        }
      });
    }
    
    onRemoveSelected(event: any, id: string){
       if(event.value !== "cancel"){
        this.showDelArchiveSelectMap.set(id, event.value);
        this.selectedForDelRows.push(id);
        this.showCheckboxSelectMap.set(id, true);
      }else{
        this.showDelArchiveSelectMap.delete(id);
        const index = this.selectedForDelRows.indexOf(id);
        this.selectedForDelRows.splice(index, 1);
        this.showCheckboxSelectMap.delete(id);
      }
    }
  saveChanges(){
    if(this.dbService.uploadStagingModified){
      firstValueFrom(this.dbService.updateUploadStaging(this.dbService.eventid,this.http))
      .then(()=> {console.log("upload staging updated")});
    }
    const keys = this.dbService.delItemsByPhoneMap.keys();
    const phones = Array.from(keys);
    phones.forEach((phone) => {
      const delArr = this.dbService.delItemsByPhoneMap.get(phone);
      console.log(JSON.stringify(delArr));
      firstValueFrom(this.dbService.updateUploadedFiles(this.dbService.eventid, delArr, phone, this.dbService.bk, this.http))
      .then((resp)=>{
        console.log(JSON.stringify(resp));
        this.unsavedChanges = false;
        this.unsavedChangesCount = 0;
        this.dialog.open(this.successfullySave, {
          width: '300px', 
          height: 'auto'  
        });
      })
    })
    
    firstValueFrom(this.dbService.updateReadlinkTemplate(this.dbService.eventid, this.http))
    .then(() => {
      console.log("links updated");
    })
    
    if(this.dbService.archivedTemplatesMap.size > 0){
      firstValueFrom(this.dbService.archiveReadlinkTemplate(this.dbService.eventid, this.http))
      .then(() => {
      console.log("archived links updated");
    })
    }
  }

   onPageChange(event: PageEvent) {
    console.log('Page event:', event);
    // You can add custom logic here if needed, for example, fetching data from an API
    // based on the new page index and page size.
  }
 
}
